import { render, staticRenderFns } from "./AiDocuments.vue?vue&type=template&id=461dba86&scoped=true"
import script from "./AiDocuments.vue?vue&type=script&lang=js"
export * from "./AiDocuments.vue?vue&type=script&lang=js"
import style0 from "./AiDocuments.vue?vue&type=style&index=0&id=461dba86&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461dba86",
  null
  
)

export default component.exports